import {Component, OnInit} from '@angular/core';
import {AbcComplettApiService} from '../../services/abc-complett-api/abc-complett-api.service';
import {ReferenzGallery} from '../../models/Laden';
import {CookieStorageService} from '../../services/cookie-storage/cookie-storage.service';
import {EventEmitterService} from '../../services/event-emitter/event-emitter.service';
import {Observable, Subscription} from 'rxjs';
import {BreakpointObserver, Breakpoints, BreakpointState} from '@angular/cdk/layout';

@Component({
  selector: 'app-referenzen',
  templateUrl: './referenzen.component.html',
  styleUrls: ['./referenzen.component.scss']
})
export class ReferenzenComponent implements OnInit {

  private handsetChange: Observable<BreakpointState>;
  private tabletChange: Observable<BreakpointState>;
  private webChange: Observable<BreakpointState>;
  private handsetChangeSubscripion: Subscription;
  private tabletChangeSubscripion: Subscription;
  private webChangeSubscripion: Subscription;

  referenzen: ReferenzGallery[];
  isHandset = true;

  get cookiesAgreed(): boolean {
    return this.cookieStorage.hasAgreed;
  }

  constructor(
    private apiService: AbcComplettApiService,
    private cookieStorage: CookieStorageService,
    private eventEmitter: EventEmitterService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.handsetChange = breakpointObserver.observe([
      Breakpoints.Handset
    ]);
    this.tabletChange = breakpointObserver.observe([
      Breakpoints.Tablet
    ]);
    this.webChange = breakpointObserver.observe([
      Breakpoints.Web
    ]);
  }

  ngOnInit() {
    this.handsetChangeSubscripion = this.handsetChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = true;
      }
    });
    this.tabletChangeSubscripion = this.tabletChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = false;
      }
    });
    this.webChangeSubscripion = this.webChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = false;
      }
    });
    this.apiService.getReferenzObjects().subscribe(data => {
      this.referenzen = data.kompetenzen;
    });
  }

  performCookieCheck() {
    if (!this.cookiesAgreed) {
      this.eventEmitter.emitCookiePopup();
    }
  }

}
